import { get } from 'lodash';
import React from 'react';
import { Typography } from '@telus-uds/components-web';
import { Td, Tr, Th, Table, TdImp, HorizontalContent, TdLabel } from './css';
import FormSummaryRow from '../../formSummaryRow';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { getServicesTotals } from '../../ocdrComponents/ocdrUtils';

const Services = ({ formFields, orderData }) => {
  return formFields.map(({ fields }) => {
    if (fields.type === 'ServiceTable') {
      const { monthly, oneTime } = getServicesTotals(
        orderData.products,
        get(orderData, 'contractTerm.value', ''),
        get(orderData, 'productSelectionOCDR.value', []),
        orderData,
        3
      );

      const { categoryName, subCategoryName } = fields.customConfigurations;
      const products = get(orderData.products, `${categoryName}`, []);
    if (subCategoryName === 'Optional Services') return;
      return (
        <>
          <Table>
            <Th style={{ width: '40%' }}><Typography>{subCategoryName}</Typography></Th>
            <Th><Typography>One-Time Pricing (per Qty)</Typography></Th>
            <Th><Typography>Recurring Price (per Qty)</Typography></Th>
            <Th><Typography>Quantity</Typography></Th>
            {Object.entries(products).map(([subCategoryName, productList]) => {
            return productList.map(
              ({ name, price, quantity, priceType, isMandatory }, idx) => {
                if (quantity <= 0) return;
                return (
                  <Tr>
                    <Td>
                      <Typography>{name} {isMandatory ? '*' : ''}</Typography>
                    </Td>
                    {priceType === 'recurring' ? (
                      <TdImp />
                    ) : (
                      <Td>
                        <HorizontalContent>
                          $
                          <input
                            type="Number"
                            onWheel={e => e.target.blur()}
                            value={price}
                            defaultValue={price}
                            placeholder="One-Time Price"
                            className="frg-input-field color-light"
                            style={{ width: '100%' }}
                            disabled
                          />
                        </HorizontalContent>
                      </Td>
                    )}
                    {priceType === 'oneTime' ? (
                      <TdImp />
                    ) : (
                      <Td>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <HorizontalContent>
                            $
                            <input
                              type="Number"
                              onWheel={e => e.target.blur()}
                              value={price}
                              placeholder="Recurring Price"
                              className="frg-input-field color-light"
                              style={{ width: '100%' }}
                              disabled
                            />
                          </HorizontalContent>
                        </div>
                      </Td>
                    )}
                    <Td>
                      <input
                        type="Number"
                        onWheel={e => e.target.blur()}
                        value={quantity}
                        placeholder={quantity}
                        className="frg-input-field color-light"
                        style={{ width: '100%' }}
                        disabled
                      />
                    </Td>
                  </Tr>
                );
              }
            ) })}
            <Tr>
            <Td ><Typography>Total</Typography></Td>
            <Td ><Typography>{oneTime.toFixed(2)}</Typography></Td>
            <Td ><Typography>{monthly.toFixed(2)}</Typography></Td>
            <Td ></Td>
            </Tr>
          </Table>
        </>
      );
    } else if (fields.type === 'MCPopup') {
      if (orderData.ocdrProductAdd.selections.length > 0) {
        return (
          <Table>
            <Th><Typography>Product</Typography></Th>
            <Th><Typography>Monthly Charges</Typography></Th>
            <Th><Typography>Monthly Discount(%)</Typography></Th>
            <Th><Typography>OneTime Charge</Typography></Th>
            <Th><Typography>Onetime Discount(%)</Typography></Th>
            <Th><Typography>Quantity</Typography></Th>
            {/* Add this column for edit/delete buttons */}
            {orderData.ocdrProductAdd.selections.map(
              (
                {
                  sku,
                  editions,
                  quantity,
                  monthlyCharges,
                  monthlyDiscount,
                  oneTimeCharge,
                  onetimeDiscount
                },
                idx
              ) => (
                // eslint-disable-next-line react/no-array-index-key
                <Tr key={`${oneTimeCharge}-${monthlyCharges}-${idx}`}>
                  <Td><Typography>{`${editions},${sku}`}</Typography></Td>
                  <Td><Typography>${monthlyCharges}</Typography></Td>
                  <Td><Typography>{monthlyDiscount}%</Typography></Td>
                  <Td><Typography>${oneTimeCharge}</Typography></Td>
                  <Td><Typography>{onetimeDiscount}%</Typography></Td>
                  <Td><Typography>{quantity}</Typography></Td>
                  {/* <Td>{formatCurrency(totalCost)}</Td>
                <Td>{formatCurrency(totalPrice)}</Td> */}
                </Tr>
              )
            )}
            <Tr>
            <TdLabel colSpan={1}>Total</TdLabel>
            <TdImp><Typography>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPrice.totalMonthlyPrice)}</Typography></TdImp>
            <Td></Td>
            <TdImp><Typography>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPrice.totalOneTimePrice)}</Typography></TdImp>
          </Tr>
          <Tr>
            <TdLabel colSpan={1}>Total with Discount</TdLabel>
            <TdImp><Typography>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalMonthlyPriceDiscount)}</Typography></TdImp>
            <Td></Td>
            <TdImp><Typography>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalOneTimePriceDiscount)}</Typography></TdImp>
          </Tr>
          </Table>
        );
      }
    } else {
      return (
        <FormSummaryRow
          key={fields.name}
          label={fields.label}
          value={get(orderData, fields.name)}
          isDollarRemove
        />
      );
    }
  });
};

export default Services;
